<div class="min-h-screen flex flex-col">
  <!-- Header: same branding bar as the date and time page -->
  <app-municipality-header></app-municipality-header>
  <!-- Previous header:
  <header class="w-full border-b border-gray-200">
    <div class="max-w-5xl mx-auto px-6 py-4 flex items-center gap-3" *ngIf="current$ | async as current; else noSelection">
      <span class="pi pi-star-fill text-brand-600 text-xl" aria-hidden="true"></span>
      <div class="font-medium text-gray-800">
        {{ 'header.titleSelected' | translate: { name: 'municipalities.' + current.id | translate } }}
      </div>
    </div>
    <ng-template #noSelection>
      <div class="max-w-5xl mx-auto px-6 py-4 flex items-center gap-3">
        <span class="pi pi-star-fill text-brand-600 text-xl" aria-hidden="true"></span>
        <div class="font-medium text-gray-800">{{ 'header.title' | translate }}</div>
      </div>
    </ng-template>
  </header>
  -->

  <!-- Main content -->
  <main class="flex-1">
    <div class="max-w-3xl mx-auto px-6 py-16 text-center">
      <h1 class="text-5xl md:text-6xl font-extrabold leading-tight tracking-tight text-gray-900">
        {{ 'home.welcomeLine1' | translate }}
        <br />
        {{ 'home.welcomeLine2' | translate }}
      </h1>
      <p class="mt-6 text-lg text-gray-600">
        {{ 'services.subtitle' | translate }}
      </p>

      <div class="mt-10">
        <button
          pButton
          type="button"
          class="p-button-lg bg-brand-600 hover:bg-brand-700 text-white px-6 py-3 rounded-xl shadow"
          [label]="'home.cta' | translate"
          (click)="bookAppointment()"
        ></button>
      </div>
    </div>
  </main>

  <!-- Footer -->
  <footer class="w-full mt-auto py-10 text-gray-600">
    <div class="max-w-4xl mx-auto px-6">
      <div class="flex justify-center gap-10 text-sm">
        <!--        <div class="flex items-center gap-2">-->
        <!--          <span class="pi pi-universal-access text-gray-500"></span>-->
        <!--          <span>{{ 'footer.accessibility' | translate }}</span>-->
        <!--        </div>-->
        <div class="flex items-center gap-2">
          <span class="pi pi-globe text-gray-500"></span>
          <span>{{ 'footer.language' | translate }}</span>
          <div class="inline-flex rounded-md overflow-hidden border border-gray-300 ml-2">
            <button (click)="switchLanguage('en')" class="px-2 py-1 hover:bg-gray-100">EN</button>
            <button (click)="switchLanguage('it')" class="px-2 py-1 hover:bg-gray-100">IT</button>
          </div>
        </div>
      </div>
      <p class="text-center text-xs mt-6">&copy; 2025 Sigmasoft. {{ 'footer.rights' | translate }}</p>
    </div>
  </footer>
</div>
